import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUser, updateUser, removeUser } from "../../services/user.service";
import { setHeaderAuthorization } from "../../services/api";

export const doGetUser = createAsyncThunk(
  "user/getUser",
  async (body, { rejectWithValue }) => {
    try {
      const response = await getUser(body);
      return {
        fullName: response.data?.fullName,
        firstTime: response.data?.isFirstTimeUser,
        planExpiry: response.data?.expiresAt * 1000,
        planUid: response.data?.plan?.planUid,
        customerId: response.data?.customerId,
        planCancel: response.data?.canceledAt,
        isTelegramJoined: response.data?.isTelegramJoined,
      };
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const doUpdateUser = createAsyncThunk(
  "user/updateUser",
  async (body, { rejectWithValue }) => {
    try {
      const response = await updateUser(body);
      return {
        fullName: response.data?.fullName,
        isTelegramJoined: response.data?.isTelegramJoined,
      };
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const doRemoveUser = createAsyncThunk(
  "user/removeUser",
  async (body, { rejectWithValue }) => {
    try {
      await removeUser(body);
      setHeaderAuthorization();
      localStorage.clear();
      return null;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);
